'use client';

import { trackEvent } from '@alltrails/amplitude/utils/track';
import Heading from '@alltrails/denali/components/Heading';
import Link from '@alltrails/denali/components/Link';
import StatusBadge from '@alltrails/denali/components/StatusBadge';
import type { FooterLinksType } from '../../generateFooterLinks';
import PrintMapsFooterLink from '../PrintMapsFooterLink';
import styles from './styles.module.scss';

const DesktopLinks = ({ href, title, amplitudeEventName, childLinks = [] }: FooterLinksType) => (
  <div className={styles.container}>
    <div className={styles.title}>
      <Heading as="h2" className={styles.heading} size="300">
        <Link
          href={href}
          noUnderline
          onClick={() => {
            if (amplitudeEventName) {
              trackEvent(amplitudeEventName);
            }
          }}
          variant="inverse"
        >
          {title}
        </Link>
      </Heading>
    </div>
    <ul>
      {childLinks.map(link => (
        <li key={link.title} className={styles.childLink}>
          {link.isPrintMapsLink ? (
            <PrintMapsFooterLink href={link.href} noUnderline size="md" variant="inverse">
              {link.title}
            </PrintMapsFooterLink>
          ) : (
            <Link
              href={link.href}
              noUnderline
              onClick={() => {
                if (link.amplitudeEventName) {
                  trackEvent(link.amplitudeEventName);
                }
              }}
              size="md"
              target={link.openInNewWindow ? '_blank' : undefined}
              variant="inverse"
            >
              {link.title}
            </Link>
          )}
          {link.badge && <StatusBadge size={link.badge.size} text={link.badge.text} emphasis={link.badge.emphasis} variant={link.badge.variant} />}
        </li>
      ))}
    </ul>
  </div>
);

export default DesktopLinks;
